var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"gj-area-title",style:({fontSize: _vm.fontSize})},[(_vm.isChunk)?_c('div',{staticClass:"gj-area_chunk"}):_vm._e(),_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }